var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOffices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#767676"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.742,32V42.92L51.281,44.9,48.82,42.92V32.873H52.1v7.439l-.824.728-.817-.728V34.621h-.82v6.1l1.635,1.456,1.646-1.455V32H48V43.355L51.281,46l3.281-2.645V32Z",
    transform: "translate(-48 -32)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOffices);
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'%3e%3ccircle cx='14' cy='14' r='14' fill='%23767676'/%3e%3cg transform='translate(10.5 7)'%3e%3cpath d='M53.742,32V42.92L51.281,44.9,48.82,42.92V32.873H52.1v7.439l-.824.728-.817-.728V34.621h-.82v6.1l1.635,1.456,1.646-1.455V32H48V43.355L51.281,46l3.281-2.645V32Z' transform='translate(-48 -32)' fill='%23fff'/%3e%3c/g%3e%3c/svg%3e";
export { ForwardRef as ReactComponent };